import { linkToDeviceDetail, linkToFacilities } from "#src/Routers/links";
import { EventContext } from "#src/contexts/EventContext";
import {
  DataTable,
  HeaderType,
  ItemAction,
  Pill,
} from "@validereinc/common-components";
import { DeviceType, EventAdapter } from "@validereinc/domain";
import { toTitleCaseString } from "@validereinc/utilities";
import React, { useContext } from "react";
import { RoutingLink } from "../RoutingLink";

export const EventDevicesTable = () => {
  const { event, isLoading, onRefetchEvent } = useContext(EventContext) || {};

  const headers: Array<HeaderType<DeviceType>> = [
    {
      key: "name",
      label: "Name",
      renderComponent: ({ item }) => (
        <RoutingLink to={linkToDeviceDetail(item.id)}>{item.name}</RoutingLink>
      ),
    },
    { key: "type.name", label: "Type" },
    {
      key: "facility.name",
      label: "Facility",
      renderComponent: ({ item }) => (
        <RoutingLink to={linkToFacilities(item.facility_id)}>
          {item.facility.name}
        </RoutingLink>
      ),
    },
    {
      key: "status",
      label: "Status",
      renderComponent: ({ item }) => (
        <Pill variant={item.status === "active" ? "success" : "default"}>
          {toTitleCaseString(item.status, {
            intent: "ui",
            exceptions: ["oil-and-gas"],
          })}
        </Pill>
      ),
    },
  ];

  const onRemove = async ({ deviceId }: { deviceId: string }) => {
    if (!event?.id) return;

    await EventAdapter.assets.deleteOne({
      assetId: deviceId,
      eventId: event?.id,
    });

    onRefetchEvent?.();
  };

  return (
    <DataTable
      headers={headers}
      items={event?.devices?.data ?? []}
      getItemId={(item) => item.id}
      isLoading={isLoading}
      getItemActions={({ item: { id } }): ItemAction[] => [
        {
          label: "Remove",
          buttonProps: {
            onClick: () => onRemove({ deviceId: id }),
            icon: "trash",
          },
        },
      ]}
    />
  );
};
